import { Mapper, Nullable, Tuple } from './typesUtils'


/**
 * Le type de retour permet à typescript de restreindre davantage le type de cette valeur
 * (voir <a href="https://www.typescriptlang.org/docs/handbook/2/narrowing.html#control-flow-analysis">ce lien</a>) <br/>
 * Par exemple : <br/>
 * <pre>
 * const exemple = <T>(a: Nullable<T>) => {
 *   if (assertNotNullOrUndefined(a)) {
 *     // Dans ce bloc le compilateur sait que A est de type T
 *   } else {
 *     // Dans ce bloc le compilateur sait que A est null ou undefined
 *   }
 *   </pre>
 }

 * @param value une valeur de type T pouvant être null ou undefined
 * @returns La fonction retourne false si le paramètre vaut null ou undefined.
 */
export const assertNotNullOrUndefined = <T>(value: Nullable<T>): value is T => {
	return typeof value !== 'undefined' && value !== null
}

/**
 * Le type de retour permet à typescript de restreindre davantage le type de cette valeur

 * @param value une valeur de type T pouvant être null ou undefined
 * @param mapper La fonction qui permet de mapper vers un nouveau type
 * @returns La fonction retourne false si le paramètre vaut null ou undefined.
 */
export const mapNullableValue = <T, U>(value: Nullable<T>, mapper: Mapper<T, U>): Nullable<U> => {
	if (assertNotNullOrUndefined(value)) {
		return mapper(value)
	}
	return value
}


/**
 * Le type de retour permet à typescript de restreindre davantage le type de cette valeur

 * @param value une valeur de type T pouvant être null ou undefined
 * @param mapper La fonction qui permet de mapper vers un nouveau type
 * @param defaultValue une valeur de type T pouvant être null ou undefined
 * @returns La fonction retourne false si le paramètre vaut null ou undefined.
 */
export const mapNullableValueWithDefault = <T, U>(value: Nullable<T>, mapper: Mapper<T, U>, defaultValue: U): U => {
	if (assertNotNullOrUndefined(value)) {
		return mapper(value)
	}
	return defaultValue
}


/**
 * Permet de créer un tuple à deux valeurs avec un type tuple et non u
 * @param a
 * @param b
 */
export const makeTuple = <T, U>(a: T, b: U): Tuple<T, U> => ([a, b])

/** Méthode de permettant de :
 * → Rajouter un '0' si les H ou M sont <10
 * ex : 9 → 09
 **/
export const padZero = (number: number) => {
	if (number < 10) {
		return `0${number}`
	}
	return `${number}`
}
